import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import HomePage from "./pages/HomePage";
import SignInPage from "./pages/SignInPage";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/" component={HomePage} exact />
        {/*   <Route path="/" component={SignInPage} exact /> */}
      </Switch>
    </Router>
  );
}

export default App;
